import { cva } from 'class-variance-authority';

export const textVariants = cva('m-0', {
  variants: {
    variant: {
      subtitle_l: 'text-2xl leading-2xl font-semibold',
      subtitle: 'text-xl leading-xl font-semibold',
      subtitle_s: 'text-lg leading-lg font-semibold',
      body_xl: 'text-xl leading-xl font-normal',
      body_l: 'text-lg leading-lg font-normal',
      body: 'text-md leading-md font-normal',
      body_s: 'text-sm leading-sm font-normal',
      label_l: 'text-md leading-md font-normal',
      label_md: 'text-sm leading-[18px] font-normal',
      label: 'text-sm leading-[18px] font-normal tracking-[1px] uppercase',
      label_s: 'text-xs leading-xs font-normal tracking-[1px] uppercase',
      label_xs: 'text-2xs leading-xs font-semibold uppercase',
      code: 'text-lg leading-md font-normal',
    },
    skin: {
      inherit: 'text-inherit',
      primary: 'text-text-neutral-primary',
      secondary: 'text-text-neutral-secondary',
      light: 'text-text-neutral-tertiary',
      brand: 'text-text-brand-primary',
      destructive: 'text-text-destructive-secondary',
      warning: 'text-text-warning-secondary',
      success: 'text-text-success-secondary',
      tertiary: 'text-text-tertiary-secondary',
      white: 'text-text-white-primary',
    },
    weight: {
      light: 'font-light',
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    fontFamily: {
      Poppins: 'font-display',
      Roboto: 'font-body',
      Fira: 'font-mono',
    },
    textAlign: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
      start: 'text-start',
      end: 'text-end',
    },
    transform: {
      uppercase: 'uppercase',
      lowercase: 'lowercase',
      capitalize: 'capitalize',
    },
    underline: {
      true: 'underline',
    },
  },
});
